import { StyleSheet } from 'aphrodite';
import { THEME } from '../../../components-v2/Theme/theme';
import { CssSelectors } from '../../../styles/styles';

const { colors, typography } = THEME;

export const styleSheet = StyleSheet.create({
	body: {
		display: 'flex',
		flexDirection: 'column',
		marginTop: 20,
		...CssSelectors.allChildren(
			{
				borderTop: THEME.common.border,
				marginTop: 18,
				paddingTop: 18,
			},
			':not(:first-child)'
		),
	},
	contactInfo: {
		color: colors.text.main,
		fontSize: typography.fontSizes.sm,
		...CssSelectors.allChildren(
			{
				marginBottom: 20,
			},
			':not(:last-child)'
		),
	},
	container: {
		minHeight: 500,
		position: 'relative',
	},
	editButton: {
		position: 'absolute',
		right: 30,
		top: 10,
	},
	header: {
		alignItems: 'center',
		display: 'flex',
		flexDirection: 'column',
		justifyContent: 'center',
		marginTop: 0,
		textAlign: 'center',
		width: '100%',
		...CssSelectors.allChildren(
			{
				marginTop: 10,
			},
			':not(:first-child)'
		),
	},
	headerBio: {
		color: colors.text.light,
		fontSize: typography.fontSizes.sm,
		textAlign: 'center',
	},
	headerTitle: {
		color: colors.text.main,
		fontSize: typography.fontSizes.xl,
		maxWidth: '100%',
	},
	loading: {
		marginTop: 30,
	},
	socialPrifles: {
		display: 'flex',
		justifyContent: 'center',
		minHeight: 20,
	},
});
